var map = {
	"./desktop": 27,
	"./desktop.js": 27,
	"./desktop.scss": 8,
	"./mobile": 28,
	"./mobile.js": 28,
	"./mobile.scss": 7
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;


//////////////////
// WEBPACK FOOTER
// ./templates/footer ^\.\/.*$
// module id = 54
// module chunks = 0